import { observer } from "@legendapp/state/react";
import { useEffect, useState } from "react";
import SearchPages from "../../../components/specific/search/SearchPage";
import InlineLoader from "../../../components/ui/inline-loader/InlineLoader";
import { pageState$, state$ } from "../../../state";
import CategoryBreadCrumbs from "../breadcrumbs/CategoryBreadCrumbs";

import { useIsFetching } from '@tanstack/react-query';
import { IUseGetFilesKey } from "../../../query/getFiles/useGetFiles.query";


const CategoryHeader = observer(() => {
  const isFullWidthState = state$.settings.isFullWidthState.get();
  const isCategoryLoadingState = useIsFetching({
    queryKey: [IUseGetFilesKey]
  });

  const hasError = pageState$.errorMessage.get() !== '';
  const pageTitle = pageState$.activeItem.title.get();
  const [searchValue, setSearchValue] = useState('');
  const [searchError, setSearchError] = useState('');
  const searchState = pageState$.searchState.get();
  const isClearPresent = searchValue.length > 0 || searchState.length > 0;


  useEffect(() => {
    if (!searchState ||
      !searchState.length) {
      setSearchValue('')
      pageState$.searchState.set('');
    }
  }, [searchState, setSearchValue, pageState$.searchState])

  return (
    <header className={`content clause-type-content animated-max-width ${isFullWidthState ? 'container-fluid' : 'container'}`}>

      <div className="row">
        <div className="col">
          <div className="header-page d-flex position-relative">
            <h2 className="content__title content__title--page d-flex">
              {pageTitle || 'Dominus Stratford'} {isCategoryLoadingState > 0 ? <InlineLoader /> : null}
            </h2>

            <SearchPages
              isLoading={isCategoryLoadingState > 0}
              customClass="overview-search"
              isDisabled={hasError || isCategoryLoadingState > 0}
              setValue={handleSearchInput}
              requestSubmit={handleSearchSubmit}
              requestClear={handleClearSearch}
              isClearPresent={isClearPresent}
              error={searchError}
              value={searchValue}
            />
          </div>

          {
            !hasError ? <CategoryBreadCrumbs /> : null
          }
        </div>
      </div>
    </header>
  )

  function handleSearchInput(event: string) {
    setSearchError('');

    if (!event ||
      !event.length) {
      setSearchError('');
    }

    if (event &&
      event.length < 3) {
      setSearchError('Minimum search must include 3 chars');
    }

    if (event &&
      event.length > 30) {
      setSearchError('Maximum allowed search is 30 chars');
    }

    setSearchValue(event);
  }

  function handleSearchSubmit(event: string) {
    if (!event ||
      !event.length) {
      return;
    }

    if (event &&
      event.length &&
      event.length < 3) {
      return setSearchError('Minimum search must include 3 chars');
    }

    if (event &&
      event.length &&
      event.length > 30) {
      return setSearchError('Maximum allowed search is 30 chars');
    }
    pageState$.searchState.set(event);
  }

  function handleClearSearch() {
    pageState$.searchState.set('');
  }
})

export default CategoryHeader;
